export const editPupSave = changes => ({
  type: 'Edit Pup - Save',
  changes,
});
